module.exports = __webpack_public_path__ + "static/media/point.dca83ebe.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/point.ogg
// module id = 290
// module chunks = 0